import React from 'react';
import { MessageCircleIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { useSeo } from '../utils/seo';
import { ConsultaForm } from '../components/forms/ConsultaForm';
import { ButtonAnchor } from '../components/ui/Button';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../utils/vehicles';
import { CONTACTO } from '../data/brand';
export function Contacto() {
  useSeo('Contacto | VCARS', 'Dejá tu consulta y un asesor de VCARS se comunica con vos. Atención por WhatsApp, email y turnos coordinados.');
  return <main className="bg-ink" data-id="element-672" data-mp="34x6emw8b6vp0">
      <div className="mx-auto grid w-full max-w-7xl gap-10 px-5 py-14 md:px-8 md:py-20 lg:grid-cols-[1fr_1.1fr] lg:gap-16" data-id="element-673" data-mp="2qw2eakgnodi0">
        <div data-id="element-674" data-mp="2vudmkqrayfy4">
          <h1 className="text-4xl font-black leading-[1.05] tracking-tight text-white md:text-[52px]" data-id="element-675" data-mp="2vvyfyd1vrsue">
            Dejá tu consulta
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-mist md:text-lg" data-id="element-676" data-mp="p2w8kwqraflv">
            Contanos qué vehículo buscás o qué operación querés realizar. Vendé, comprá o
            financiá tu próximo auto con asesoramiento profesional.
          </p>

          <ul className="mt-9 space-y-4" data-id="element-677" data-mp="1nzjk6y0assk6">
            <li className="flex items-start gap-3 text-[15px] text-white/90" data-id="element-678" data-mp="21rq2oqqxbbms">
              <MessageCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#25c264]" aria-hidden="true" data-id="element-679" data-mp="21tu4921cnyjw" />
              WhatsApp / Ventas: {CONTACTO.ventasTelefono} — {CONTACTO.ventasNombre}
            </li>
            <li className="flex items-start gap-3 text-[15px] text-white/90" data-id="element-680" data-mp="1528rjw968xdp">
              <PhoneIcon className="mt-0.5 h-5 w-5 shrink-0 text-neon" aria-hidden="true" data-id="element-681" data-mp="1j102j9sqm2xm" />
              Administración general: {CONTACTO.adminTelefono}
            </li>
            <li className="flex items-start gap-3 text-[15px] text-white/90" data-id="element-682" data-mp="1e49i6a9wgl6e">
              <MailIcon className="mt-0.5 h-5 w-5 shrink-0 text-neon" aria-hidden="true" data-id="element-683" data-mp="2ueu46lqt57tt" />
              {CONTACTO.email}
            </li>
            <li className="flex items-start gap-3 text-[15px] text-white/90" data-id="element-684" data-mp="1n3wayryoscm9">
              <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-neon" aria-hidden="true" data-id="element-685" data-mp="1n60cj3944zjd" />
              {CONTACTO.ubicacion}
            </li>
          </ul>

          <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="whatsapp" size="lg" className="mt-9" data-id="element-686" data-mp="1w5nh1xx52lgn">
            <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-687" data-mp="14do9eeamxu86" />
            Hablar con un vendedor
          </ButtonAnchor>
        </div>

        <ConsultaForm data-id="element-688" data-mp="18fjapiskg7ly" />
      </div>
    </main>;
}